<script lang="ts">let { text } = $props();
</script>

<span class="vip-modern-eyebrow">{text}</span>

<style>
	.vip-modern-eyebrow {
    display: inline-block;
    white-space: nowrap;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    background-color: rgb(255 255 255 / 0.05);
    color: var(--color-primary-500);
    border-radius: 9999px;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
}
</style>
